module.exports = __webpack_public_path__ + "img/service-resource07.6af9a78d.jpg";